import React from "react";
import logoImg from "../assets/flightle-logo.png";

export default function TopBar({
  onBack,
  onStats,
  onHelp,
  showBack = true
}) {
  return (
    <div style={styles.topBar}>

      {/* LEFT */}
      <div style={styles.side}>
        <button
          style={{
            ...styles.iconButton,
            visibility: showBack ? "visible" : "hidden"
          }}
          onClick={showBack ? onBack : undefined}
          aria-label="Go back"
          aria-hidden={!showBack}
          tabIndex={showBack ? 0 : -1}
        >
          ←
        </button>

        <button
          style={styles.iconButton}
          onClick={onStats}
          aria-label="Stats and achievements"
        >
          📊
        </button>
      </div>

      {/* CENTER */}
      <div style={styles.centerContainer}>
        <img 
          src={logoImg} 
          alt="Flightle Logo" 
          style={styles.logoInline} 
        />
      </div>

      {/* RIGHT */}
      <div style={styles.sideRight}>
        <button
          onClick={onHelp}
          style={styles.iconButton}
          aria-label="Help"
        >
          ?
        </button>

        <a
          href="https://ko-fi.com/flightlematt"
          target="_blank"
          rel="noreferrer"
          style={styles.iconButton}
          aria-label="Support on Ko-fi"
        >
          ☕
        </a>
      </div>

    </div>
  );
}

const styles = {
  topBar: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: 60,
    background: "#deecfc",
    zIndex: 1000,

    display: "grid",
    gridTemplateColumns: "80px 1fr 80px",
    alignItems: "center",

    maxWidth: 600,
    margin: "0 auto",
    padding: "0 8px"
  },

  side: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 4
  },

  sideRight: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 8
  },

  centerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 6,
    height: "100%"
  },

  titleText: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#000000"
  },

  logoInline: {
    height: 48,
    width: "auto",
    objectFit: "contain"
  },

  iconButton: {
    fontSize: 21,
    textDecoration: "none",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: 8,
    color: "black"
  }
};